const keys = {
  // TUPER
  83178: {
    key: 83178,
    notificaFornecedor: {
      visivel: false,
      hasFilter: false,
      stringFilter: false,
      isProduto: false,
      valorPadrao: false,
    },
    codigoInterno: {
      visivel: true,
      hasFilter: true,
      stringFilter: true,
      isProduto: true,
      valorPadrao: undefined,
    },
  },
  // Norsil
  266143: {
    key: 266143,
    notificaFornecedor: {
      visivel: true,
      hasFilter: false,
      stringFilter: false,
      isProduto: false,
      valorPadrao: false,
    },
  },
};

const values = Object.keys(keys)
  .map(key => keys[key]);

export default {
  keys,
  values,
};
